export default __webpack_public_path__ + "static/media/user.1d962508.svg";